export default {
  unavailable: {
    title: 'Accès en libre-service partenaire limité',
    description:
      "Cette section n'est pas disponible pour les partenaires en intégration libre-service. Veuillez contacter votre responsable de compte si vous en avez besoin.",
  },
};
